import { Link } from "react-router-dom";

const highlights = [
  { icon: "ri-flashlight-line", label: "实时资讯", desc: "追踪最新影视动态" },
  { icon: "ri-compass-3-line", label: "精选推荐", desc: "严选高质量好作品" },
  { icon: "ri-bookmark-3-line", label: "收藏清单", desc: "本地保存想看内容" },
];

export default function SiteIntro() {
  return (
    <section className="mt-12 overflow-hidden rounded-lg border border-background-200 bg-primary-950">
      <div className="grid grid-cols-1 gap-8 p-6 md:p-10 lg:grid-cols-[1.4fr_1fr] lg:items-center">
        <div>
          <h2 className="font-heading text-2xl font-black text-background-50 md:text-3xl">
            关于棒棒<span className="text-accent-500">TV</span>
          </h2>
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-background-300 md:text-base">
            棒棒TV 是一个专注影视剧资讯与精选推荐的综合内容平台。我们汇聚电影、电视剧、综艺与纪录片四大板块，通过分类浏览、专题合集与个性化推荐，帮助每一位观众更快找到值得花时间的好作品。所有内容均为资讯与推荐展示。
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link
              to="/about"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600"
            >
              了解更多
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/search"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-100/30 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/10"
            >
              <i className="ri-search-line"></i>
              搜索影视
            </Link>
          </div>
        </div>
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-3 lg:grid-cols-1">
          {highlights.map((item) => (
            <div key={item.label} className="flex items-center gap-3 rounded-md bg-primary-900 px-4 py-3">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-800 text-accent-500">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <span>
                <span className="block text-sm font-bold text-background-50">{item.label}</span>
                <span className="block text-xs text-background-400">{item.desc}</span>
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}